import App from '../../components/App';
import props from '../../configs/propsSmall';

export default function FontGenerator() {
  return <App {...props} />;
}
